export default __webpack_public_path__ + "static/media/washupLogo.4651b508.png";